export enum PageURL {
  APPLICATIONS = '/applications',
  APPLICATION_CREATE = '/application/create',
  APPLICATION_EDIT = '/application/edit/:id',
  APPLICATION_DETAILS = '/application/:id',
  BTL_APPLICATION_CREATE = '/btlapplication/create',
  BTL_APPLICATION_EDIT = '/btlapplication/edit/:id',
  DASHBOARD = '/dashboard',
  FAQ = 'https://help.strideup.co/en/collections/3257393-eligibility',
  INCOME_REQUIREMENTS = 'https://help.strideup.co/en/articles/5808264-what-are-the-minimum-income-requirements',
  LOGIN = '/login',
  SIGNUP = '/signup',
  NOT_FOUND = '/404',
  PRODUCTS = '/products',
  PRODUCTS_EDIT = '/products/:id/edit',
  PRODUCTS_NEW = '/products/new',
  RECIDENCY_REQUIREMENTS = 'https://help.strideup.co/en/articles/5808261-do-i-need-to-be-a-uk-national-to-apply',
  TERMS_AND_CONDITIONS = 'https://docs.strideup.co/Intermediary+Terms+of+Business.pdf',
  ROOT = '/',
  USERS = '/users',
  CALCULATOR = '/calculator',
  CRITERIA = 'https://intermediaries.strideup.co/criteria',
  RESOURCE_HUB = 'https://intermediaries.strideup.co/resource-hub',
  TERMS_OF_BUSINESS_AGREEMENT = 'https://docs.strideup.co/Terms+of+Business+Agreement.pdf',
  BTL_AFFORDABILITY = 'https://docs.strideup.co/StrideUp+-+BTL+Affordability.xlsm',
  INTRODUCER_AGREEMENT = 'https://docs.strideup.co/Introducer+Agreement.pdf',
  GIFTED_DEPOSIT_DECLARATION_FORM = 'https://docs.strideup.co/Gifted%20Deposit%20Declaration.docx',
  PRIVACY_POLICY = 'https://www.strideup.co/privacy-policy',
}

export const getPageURL = (url: PageURL, params?: { [key: string]: string | number }) => {
  if (!params) return url;

  return Object.keys(params).reduce((acc, key) => acc.replace(`:${key}`, params[key].toString()), url);
};

export const getPageURLWithSection = (
  url: PageURL,
  params?: { [key: string]: string | number },
  queryStringParams?: Record<string, string | number>,
): string => {
  let updatedUrl: string = url;

  // Replace URL parameters with the given values
  if (params) {
    updatedUrl = getPageURL(url, params);
  }

  // Append query parameters if present
  if (queryStringParams) {
    const searchParams = new URLSearchParams(
      Object.entries(queryStringParams).map(([key, value]) => [key, value.toString()]),
    );

    return `${updatedUrl}?${searchParams.toString()}`;
  }

  // Return the base URL if no query parameters are added
  return updatedUrl;
};
